import React from "react";

function Hero(){
    return(
        <hero>
            <div className="hero--box">
                <div className="hero--text">
                    <h1 className="hero--title">Veegana.</h1>
                    <p className="hero--description"> Green Recipes from your fridge to US!</p>
                </div>
            </div>
        </hero>
    )
    }
    
    export default Hero;